/**
 * Discord 登录入口地址。
 *
 * 真正的授权页在 notify-hub 上（Luis 那边）：`{notify-hub}/discord/login?app_code=…` 直接 302 到
 * Discord OAuth，授权完 notify-hub 把人重定向回我们登记的 business_callback_url。这里只负责把人送过去。
 *
 * Luis 的接入规范里登录链接是绑定成功后由机器人私信推给本人的，没写业务前端自己放入口；
 * leo 2026-10-19 要求登录页直接放这个按钮（点一下去 Discord、授权完就回来），不用再去私信里翻链接。
 * 这条地址是 notify-hub 的公开入口，不带任何密钥，前端拼它没有安全问题。
 *
 * **按域名逐条写死**，同 lib/super-admin.ts：这一页在没登录时就要能点，拿不到后端配置。
 * 不在表里的域名返回空串，按钮不画。构建时变量 VITE_DISCORD_LOGIN_URL 仍可覆盖，给本地调别的 notify-hub 用。
 * 生产入口与 wrangler.admin.jsonc env.prod 的 NOTIFY_HUB_BASE_URL / APP_CODE 是同一套，改要一起改。
 */
const TEST_ENTRY = "https://notify-hub-test.pages.dev/discord/login?app_code=idol-ludo";
const PROD_ENTRY = "https://notify.hellopay.cc/discord/login?app_code=idol-ludo";

const ENTRY_BY_HOST: Record<string, string> = {
  "aeroplane-admin.pwtk-dev.work": TEST_ENTRY,
  "aeroplane-admin.xdreamstar2025.workers.dev": TEST_ENTRY,
  "aeroplane-admin.idolcard.cc": PROD_ENTRY,
};

const RAW = (import.meta.env.VITE_DISCORD_LOGIN_URL ?? "") as string;

export function discordEntry(): string {
  if (RAW.trim()) return RAW.trim();
  const host = typeof location !== "undefined" ? location.hostname : "";
  // 本地开发的接口代理到 test（vite.config.ts），回跳地址也登记在 test 域名上，入口跟 test 走
  if (host === "localhost" || host === "127.0.0.1") return TEST_ENTRY;
  return ENTRY_BY_HOST[host] ?? "";
}
export const discordConfigured = (): boolean => discordEntry().length > 0;

/** 本地开发：不查绑没绑 Discord（leo 2026-10-19），登录页的 Discord 按钮照常 */
export const isLocalDev = (): boolean => typeof location !== "undefined" && (location.hostname === "localhost" || location.hostname === "127.0.0.1");
